var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCategoryList = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "List")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3-Copy",
    fill: "#EBEFF5",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 15,
    cy: 15,
    r: 15
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9.000000, 9.000000)",
    stroke: "#383E41"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1-Copy-2",
    points: "0 2.76923077 12 2.76923077 12 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1-Copy-4",
    points: "0 12 11 12 11 9.23076923 0 9.23076923"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1-Copy-5",
    points: "0 7.38461538 8 7.38461538 8 4.61538462 0 4.61538462"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCategoryList, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CategoryList.023d22f0.svg";
export { ForwardRef as ReactComponent };